/**
 * Carrousel mobile du bloc « L'expérience Cercle des Voyages ».
 *
 * Le défilement est natif (scroll-snap, cf. components/_experience.scss) : ce
 * module ne gère que la synchronisation des puces — mise à jour au scroll et
 * navigation au clic. En desktop la grille n'est pas scrollable et les puces
 * sont masquées, il n'y a donc rien à désactiver au resize.
 */

const INITED_ATTR = 'data-cdv-experience-slider-inited';

/**
 * Index de la slide la plus proche du centre de la zone visible.
 * @param {HTMLElement} track
 * @param {HTMLElement[]} slides
 * @returns {number}
 */
function getVisibleIndex(track, slides) {
  const trackRect = track.getBoundingClientRect();
  const trackCenter = trackRect.left + trackRect.width / 2;

  let closest = 0;
  let smallestDistance = Infinity;

  slides.forEach((slide, index) => {
    const rect = slide.getBoundingClientRect();
    const distance = Math.abs(rect.left + rect.width / 2 - trackCenter);

    if (distance < smallestDistance) {
      smallestDistance = distance;
      closest = index;
    }
  });

  return closest;
}

/**
 * Initialise un bloc `.cdv-experience`.
 * @param {HTMLElement} section
 * @returns {boolean} true si initialisé
 */
function initSection(section) {
  if (!section || section.getAttribute(INITED_ATTR) === 'true') return false;

  const track = section.querySelector('.cdv-experience__grid');
  const dots = Array.from(section.querySelectorAll('.cdv-experience__dot'));
  const slides = track ? Array.from(track.querySelectorAll('.cdv-experience__item')) : [];

  if (!track || dots.length < 2 || slides.length !== dots.length) return false;

  let currentIndex = 0;

  const setActive = (index) => {
    if (index === currentIndex) return;
    currentIndex = index;

    dots.forEach((dot, i) => {
      const isActive = i === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(() => {
      ticking = false;
      setActive(getVisibleIndex(track, slides));
    });
  }, { passive: true });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const slide = slides[index];
      const left = slide.getBoundingClientRect().left
        - track.getBoundingClientRect().left
        + track.scrollLeft;

      track.scrollTo({ left, behavior: 'smooth' });
      setActive(index);
    });
  });

  section.setAttribute(INITED_ATTR, 'true');
  return true;
}

export function initExperienceSlider() {
  document.querySelectorAll('.cdv-experience').forEach(initSection);
}
